<div class="pre-footer"><img src="assets/images/line-prefoter.svg" alt="bg-prefooter"></div>
<!--===================== Search Domain ========================-->
<div class="search-domain animatedParent">
  <div class="container animated fadeInUpShort">
    <!--<div class="row">
      <div class="col-md-4 col-xs-12">
        <h3>Search Your Domain</h3>
      </div>
      <div class="col-md-8 col-xs-12">
        <form>
          <div class="form-group">
            <input type="text" placeholder="Domain Name">
            <select>
              <option value=".com">.com</option>
              <option value=".ua">.ua</option>
              <option value=".nu">.nu</option>
            </select>
          </div>
          <button class="custom-btn green">Search</button>
        </form>
      </div>
    </div>-->
  </div>
</div>
<!--===================== End of Search Domain ========================-->
<!--===================== Footer ========================-->
<footer>
  <div class="container">
    <div class="widget-footer">
      <!--<h4>Product</h4>
      <ul>
        <li><a href="service-page.html">Web Hosting</a></li>
        <li><a href="service-page.html">Shared Hosting</a></li>
        <li><a href="service-page.html">Dedicated Server</a></li>
        <li><a href="service-page.html">Private Cloud</a></li>
      </ul>-->
    </div><!--widget-footer-->
    <div class="widget-footer">
      <!--<h4>Company</h4>
      <ul>
        <li><a href="about.html">About Us</a></li>
        <li><a href="service-page.html">Careers</a></li>
        <li><a href="blog-list.html">Blog</a></li>
        <li><a href="contact.html">Contact</a></li>
      </ul>-->
    </div><!--widget-footer-->
    <div class="widget-footer">
      <!--<h4>Support</h4>
      <ul>
        <li><a href="service-page.html">FAQ</a></li>
        <li><a href="contact.html">Contact Us</a></li>
      </ul>-->
    </div><!--widget-footer-->
    <div class="widget-footer">
      <h4>Контакты</h4>
      <ul>

        <li><a href="#">телефон горячей линии  в г. Курск: <br> 220-961 <br> 8(4712)76-02-03</a></li>
        <li><a href="http://mailto:support@octopus-online.ru">support@octopus-online.ru</a></li>
        <li><a href="http://mailto:request@octopus-online.ru">Заявка на подключение, request@octopus-online.ru</a></li>
        <li><a href="#">для остальных регионов России:
          <br> 8-800-937-99921</a></li>
      </ul>
    </div><!--widget-footer-->
    <div class="widget-footer last">
      <a href="index.html"><img src="assets/images/logo.png" alt="logo"></a>
      <!-- <p>Мы в соц. сетях </p>
      <ul class="social-icon">
        <li><a href="#"><i class="fa fa-facebook"></i></a></li>
        <li><a href="#"><i class="fa fa-instagram"></i></a></li>
        <li><a href="#"><i class="fa fa-youtube"></i></a></li>
      </ul> -->
    </div><!--widget-footer-->
    <div class="copyright">
      <p>&copy; Copyright 2020 Octopus, All Rights Reserved</p>
    </div><!--copyright-->
  </div>
</footer>
